import { createTreasuryClient, readFundCreateRequest } from '@liquid-spirit/api/domains/treasury';
import apiClient from './apiClient';

const treasury = createTreasuryClient(apiClient);

export async function listCommunityTreasuryFunds({ token, ...options }) {
  return treasury.listFunds({ ...options, token });
}

export async function addTreasuryFundBalance({ token, fundId, amount, note, ...options }) {
  return treasury.addFundBalance(fundId, { amount, note }, { ...options, token });
}

export async function createTreasuryFund({ token, code, fundName, name, currency, description, balance, ...options }) {
  readFundCreateRequest({code, fundName, name, currency, description, balance: balance ?? 0});
  const normalizedCode = String((code || '').trim());
  const normalizedName = String((fundName || name || '').trim());
  return treasury.createFund(
    {
      code: normalizedCode,
      fundName: normalizedName,
      currency: currency || 'AUD',
      description: description || '',
      balance: balance ?? 0,
    },
    { ...options, token },
  );
}

export async function setTreasuryFundBalance({ token, fundId, balance, note, ...options }) {
  return treasury.setFundBalance(fundId, { balance, note }, { ...options, token });
}

export async function registerTreasuryFundTransaction({ token, fundId, amount, note, ...options }) {
  return treasury.registerFundTransaction(fundId, { amount, note }, { ...options, token });
}

export async function listTreasuryTransactions({ token, fundId, limit = 25, ...options }) {
  return treasury.listTransactions({ fundId, limit }, { ...options, token });
}

export async function listTreasuryWallets({ token, fundId, ...options }) {
  return treasury.listWallets({ fundId }, { ...options, token });
}

export async function syncTreasuryWallet({ token, walletId, ...options }) {
  return treasury.syncWallet(walletId, { ...options, token });
}

export async function updateTreasuryWallet({ token, walletId, updates, ...options }) {
  return treasury.updateWallet(walletId, updates, { ...options, token });
}

export async function syncTreasuryFundWallets({ token, fundId, ...options }) {
  return treasury.syncFundWallets(fundId, { ...options, token });
}

export async function syncTreasuryCommunityWallets({ token, ...options }) {
  return treasury.syncCommunityWallets({ ...options, token });
}

export async function setTreasuryFundReconciliationReview({ token, fundId, status, note, ...options }) {
  return treasury.setFundReconciliationReview(fundId, { status, note }, { ...options, token });
}

export async function setTreasuryFundDonationConfig({ token, fundId, donationConfig, ...options }) {
  return treasury.setFundDonationConfig(fundId, donationConfig, { ...options, token });
}

export async function createTreasuryPaymentIntent({ token, fundId, expectedAmount, suggestedAmount, memberNote, ...options }) {
  return treasury.createPaymentIntent(
    { fundId, expectedAmount, suggestedAmount, memberNote },
    { ...options, token },
  );
}

export async function listTreasuryPaymentIntents({ token, limit = 25, ...options }) {
  return treasury.listPaymentIntents({ limit }, { ...options, token });
}

export async function submitTreasuryPaymentIntent({ token, intentId, walletAddress, txHash, ...options }) {
  return treasury.submitPaymentIntent(intentId, { walletAddress, txHash }, { ...options, token });
}

export async function reviewTreasuryPaymentIntent({ token, intentId, operatorReviewStatus, operatorReviewNote, status, ...options }) {
  return treasury.reviewPaymentIntent(
    intentId,
    { operatorReviewStatus, operatorReviewNote, status },
    { ...options, token },
  );
}
